import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getCountries = () => client.get("/countries").then((r) => r.data.countries);
export const getTax = () => client.get("/tax").then((r) => r.data);
export const getCountryDetail = (name) => client.get(`/country/${encodeURIComponent(name)}`).then((r) => r.data);
export const checkEligibility = (profile) => client.post("/eligibility/check", profile).then((r) => r.data);
export const getReport = (id) => client.get(`/report/${id}`).then((r) => r.data);
export const getPricing = () => client.get("/pricing").then((r) => r.data);
export const createCheckout = (payload) => client.post("/checkout/session", payload).then((r) => r.data);
export const createUpgrade = (payload) => client.post("/checkout/upgrade", payload).then((r) => r.data);
export const getCheckoutStatus = (sid) => client.get(`/checkout/status/${sid}`).then((r) => r.data);
export const retrieveReports = (email) => client.post("/report/retrieve", { email }).then((r) => r.data);
export const tier2Interest = (payload) => client.post("/tier2/interest", payload).then((r) => r.data);
export const logEvent = (event, report_id, props = {}) =>
  client.post("/analytics/event", { event, report_id, props }).catch(() => {});
export const pdfUrl = (id) => `${API}/report/${id}/pdf`;

// Lifestyle preference matcher (V1.1)
export const getMatchConfig = () => client.get("/match/config").then((r) => r.data);
export const runMatch = (payload) => client.post("/match", payload).then((r) => r.data);

// Admin
export const adminHeaders = (token) => ({ headers: { "X-Admin-Token": token } });
export const adminStats = (t) => client.get("/admin/stats", adminHeaders(t)).then((r) => r.data);
export const adminCountries = (t) => client.get("/admin/countries", adminHeaders(t)).then((r) => r.data);
export const adminCountry = (t, name) => client.get(`/admin/country/${encodeURIComponent(name)}`, adminHeaders(t)).then((r) => r.data);
export const adminUpdateCountry = (t, name, payload) => client.put(`/admin/country/${encodeURIComponent(name)}`, payload, adminHeaders(t)).then((r) => r.data);
export const adminGetSettings = (t) => client.get("/admin/settings", adminHeaders(t)).then((r) => r.data);
export const adminUpdateSettings = (t, payload) => client.put("/admin/settings", payload, adminHeaders(t)).then((r) => r.data);
export const adminPurchases = (t) => client.get("/admin/purchases", adminHeaders(t)).then((r) => r.data);
export const adminReports = (t) => client.get("/admin/reports", adminHeaders(t)).then((r) => r.data);
export const adminRegenerate = (t, id) => client.post(`/admin/report/${id}/regenerate`, {}, adminHeaders(t)).then((r) => r.data);
export const adminSetConfidential = (t, id, confidential) =>
  client.patch(`/admin/report/${id}/confidential`, { confidential }, adminHeaders(t)).then((r) => r.data);
export const adminTier2 = (t) => client.get("/admin/tier2", adminHeaders(t)).then((r) => r.data);
export const adminAnalytics = (t) => client.get("/admin/analytics", adminHeaders(t)).then((r) => r.data);
export const adminLifestyleSeed = (t) =>
  client.post("/admin/lifestyle/seed", {}, adminHeaders(t)).then((r) => r.data);
